export { default as Accordion } from '../../components/elements/Accordion.vue'
export { default as AccordionButton } from '../../components/elements/AccordionButton.vue'
export { default as Activity } from '../../components/elements/Activity.vue'
export { default as ActivityTimeline } from '../../components/elements/ActivityTimeline.vue'
export { default as Article } from '../../components/elements/Article.vue'
export { default as ArticleSearchCard } from '../../components/elements/ArticleSearchCard.vue'
export { default as ArticleSlider } from '../../components/elements/ArticleSlider.vue'
export { default as Burger } from '../../components/elements/Burger.vue'
export { default as Button } from '../../components/elements/Button.vue'
export { default as Country } from '../../components/elements/Country.vue'
export { default as CountryWithPopover } from '../../components/elements/CountryWithPopover.vue'
export { default as Date } from '../../components/elements/Date.vue'
export { default as DirectionButton } from '../../components/elements/DirectionButton.vue'
export { default as Download } from '../../components/elements/Download.vue'
export { default as ExpertCard } from '../../components/elements/ExpertCard.vue'
export { default as FilterBlock } from '../../components/elements/FilterBlock.vue'
export { default as FilterCountry } from '../../components/elements/FilterCountry.vue'
export { default as Guide } from '../../components/elements/Guide.vue'
export { default as HsUpdates } from '../../components/elements/HsUpdates.vue'
export { default as HubSection } from '../../components/elements/HubSection.vue'
export { default as HubUpdate } from '../../components/elements/HubUpdate.vue'
export { default as Icon } from '../../components/elements/Icon.vue'
export { default as ImpersonationBanner } from '../../components/elements/ImpersonationBanner.vue'
export { default as Info } from '../../components/elements/Info.vue'
export { default as LicenseList } from '../../components/elements/LicenseList.vue'
export { default as Link } from '../../components/elements/Link.vue'
export { default as Loading } from '../../components/elements/Loading.vue'
export { default as MustRead } from '../../components/elements/MustRead.vue'
export { default as NoteButton } from '../../components/elements/NoteButton.vue'
export { default as Pagination } from '../../components/elements/Pagination.vue'
export { default as PieChart } from '../../components/elements/PieChart.vue'
export { default as Range } from '../../components/elements/Range.vue'
export { default as RecentUpdate } from '../../components/elements/RecentUpdate.vue'
export { default as RegulatoryDeadlines } from '../../components/elements/RegulatoryDeadlines.vue'
export { default as RelatedLink } from '../../components/elements/RelatedLink.vue'
export { default as ReportSlider } from '../../components/elements/ReportSlider.vue'
export { default as RequirementHistory } from '../../components/elements/RequirementHistory.vue'
export { default as RequirementList } from '../../components/elements/RequirementList.vue'
export { default as RequirementReportList } from '../../components/elements/RequirementReportList.vue'
export { default as Search } from '../../components/elements/Search.vue'
export { default as SearchDate } from '../../components/elements/SearchDate.vue'
export { default as SearchMultiple } from '../../components/elements/SearchMultiple.vue'
export { default as SearchSidebar } from '../../components/elements/SearchSidebar.vue'
export { default as SectionBanner } from '../../components/elements/SectionBanner.vue'
export { default as SpreadsheetGenerator } from '../../components/elements/SpreadsheetGenerator.vue'
export { default as SubTitle } from '../../components/elements/SubTitle.vue'
export { default as SubTitleReport } from '../../components/elements/SubTitleReport.vue'
export { default as Swiper } from '../../components/elements/Swiper.vue'
export { default as Tabs } from '../../components/elements/Tabs.vue'
export { default as Tag } from '../../components/elements/Tag.vue'
export { default as TextContent } from '../../components/elements/TextContent.vue'
export { default as Tip } from '../../components/elements/Tip.vue'
export { default as Title } from '../../components/elements/Title.vue'
export { default as TitleBlock } from '../../components/elements/TitleBlock.vue'
export { default as Tooltip } from '../../components/elements/Tooltip.vue'
export { default as TrackerCard } from '../../components/elements/TrackerCard.vue'
export { default as Update } from '../../components/elements/Update.vue'
export { default as Viq } from '../../components/elements/Viq.vue'
export { default as WatchListCard } from '../../components/elements/WatchListCard.vue'
export { default as HsArticle } from '../../components/elements/hsArticle.vue'
export { default as GlobalFilterNav } from '../../components/global/GlobalFilterNav.vue'
export { default as Chart } from '../../components/chart/Chart.vue'
export { default as ChecklistsChecklistDialog } from '../../components/checklists/ChecklistDialog.vue'
export { default as ChecklistsChecklistOverview } from '../../components/checklists/ChecklistOverview.vue'
export { default as ChecklistsChecklistStatCard } from '../../components/checklists/ChecklistStatCard.vue'
export { default as ChecklistsChecklistVideoEmbedModal } from '../../components/checklists/ChecklistVideoEmbedModal.vue'
export { default as DialogAddNote } from '../../components/dialog/AddNote.vue'
export { default as DialogAllNotes } from '../../components/dialog/AllNotes.vue'
export { default as DialogBase } from '../../components/dialog/Base.vue'
export { default as DialogBulderDialog } from '../../components/dialog/BulderDialog.vue'
export { default as DialogConfirmDelete } from '../../components/dialog/ConfirmDelete.vue'
export { default as DialogFilterSaver } from '../../components/dialog/FilterSaver.vue'
export { default as DialogOptionsButtons } from '../../components/dialog/OptionsButtons.vue'
export { default as Footer } from '../../components/footer/Footer.vue'
export { default as Header } from '../../components/header/Header.vue'
export { default as HeaderAuth } from '../../components/header/HeaderAuth.vue'
export { default as HeaderMobileHeader } from '../../components/header/MobileHeader.vue'
export { default as HomeAlertTriage } from '../../components/home/AlertTriage.vue'
export { default as HomeFeedFilters } from '../../components/home/FeedFilters.vue'
export { default as HomeBanner } from '../../components/home/HomeBanner.vue'
export { default as HomeFeed } from '../../components/home/HomeFeed.vue'
export { default as HomeHomepageV1 } from '../../components/home/HomepageV1.vue'
export { default as HomeHomepageV2 } from '../../components/home/HomepageV2.vue'
export { default as MapsHorizonScanningMap } from '../../components/maps/HorizonScanningMap.vue'
export { default as ProfileNote } from '../../components/profile/Note.vue'
export { default as ProfileMenu } from '../../components/profile/ProfileMenu.vue'
export { default as ProfileUserReportListCard } from '../../components/profile/UserReportListCard.vue'
export { default as ReportbuilderBuilder } from '../../components/reportbuilder/Builder.vue'
export { default as ReportbuilderMultiSelectWrapper } from '../../components/reportbuilder/MultiSelectWrapper.vue'
export { default as ReportbuilderReportCountry } from '../../components/reportbuilder/ReportCountry.vue'
export { default as ReportbuilderReportCountryScrollable } from '../../components/reportbuilder/ReportCountryScrollable.vue'
export { default as ReportbuilderReportRequirement } from '../../components/reportbuilder/ReportRequirement.vue'
export { default as ReportbuilderStepBoxes } from '../../components/reportbuilder/StepBoxes.vue'
export { default as ReportbuilderStepNav } from '../../components/reportbuilder/StepNav.vue'
export { default as SearchV1 } from '../../components/search/SearchV1.vue'
export { default as SearchV2 } from '../../components/search/SearchV2.vue'
export { default as SectionPageFunctions } from '../../components/section/PageFunctions.vue'
export { default as SectionSwiper } from '../../components/section/SectionSwiper.vue'
export { default as SectionSorting } from '../../components/section/Sorting.vue'
export { default as SidebarExpert } from '../../components/sidebar/Expert.vue'
export { default as SidebarHots } from '../../components/sidebar/Hots.vue'
export { default as SidebarLibrary } from '../../components/sidebar/Library.vue'
export { default as SidebarProfileNav } from '../../components/sidebar/ProfileNav.vue'
export { default as Sidebar } from '../../components/sidebar/Sidebar.vue'
export { default as SidebarTitle } from '../../components/sidebar/SidebarTitle.vue'
export { default as SidebarSummary } from '../../components/sidebar/Summary.vue'
export { default as SidebarWatchlist } from '../../components/sidebar/Watchlist.vue'
export { default as ViqActionChips } from '../../components/viq/ViqActionChips.vue'
export { default as ViqArticleDetail } from '../../components/viq/ViqArticleDetail.vue'
export { default as ViqBoardReport } from '../../components/viq/ViqBoardReport.vue'
export { default as ViqChatPanel } from '../../components/viq/ViqChatPanel.vue'
export { default as ViqCitationPill } from '../../components/viq/ViqCitationPill.vue'
export { default as ViqCompareMarkets } from '../../components/viq/ViqCompareMarkets.vue'
export { default as ViqConfidenceBadge } from '../../components/viq/ViqConfidenceBadge.vue'
export { default as ViqConversationItem } from '../../components/viq/ViqConversationItem.vue'
export { default as ViqConversationList } from '../../components/viq/ViqConversationList.vue'
export { default as ViqExpansionOpportunity } from '../../components/viq/ViqExpansionOpportunity.vue'
export { default as ViqExpertCommentary } from '../../components/viq/ViqExpertCommentary.vue'
export { default as ViqExpertUpsell } from '../../components/viq/ViqExpertUpsell.vue'
export { default as ViqFeedback } from '../../components/viq/ViqFeedback.vue'
export { default as ViqFollowUps } from '../../components/viq/ViqFollowUps.vue'
export { default as ViqGapAnalysis } from '../../components/viq/ViqGapAnalysis.vue'
export { default as ViqGapQuestions } from '../../components/viq/ViqGapQuestions.vue'
export { default as ViqGapResults } from '../../components/viq/ViqGapResults.vue'
export { default as ViqInputArea } from '../../components/viq/ViqInputArea.vue'
export { default as ViqLensBuilder } from '../../components/viq/ViqLensBuilder.vue'
export { default as ViqLensIcon } from '../../components/viq/ViqLensIcon.vue'
export { default as ViqLensIndicator } from '../../components/viq/ViqLensIndicator.vue'
export { default as ViqLensSelector } from '../../components/viq/ViqLensSelector.vue'
export { default as ViqMarketEntry } from '../../components/viq/ViqMarketEntry.vue'
export { default as ViqMessageAssistant } from '../../components/viq/ViqMessageAssistant.vue'
export { default as ViqMessageList } from '../../components/viq/ViqMessageList.vue'
export { default as ViqMessageLoading } from '../../components/viq/ViqMessageLoading.vue'
export { default as ViqMessageUser } from '../../components/viq/ViqMessageUser.vue'
export { default as ViqPage } from '../../components/viq/ViqPage.vue'
export { default as ViqPdfExport } from '../../components/viq/ViqPdfExport.vue'
export { default as ViqRelatedContent } from '../../components/viq/ViqRelatedContent.vue'
export { default as ViqRelatedTopics } from '../../components/viq/ViqRelatedTopics.vue'
export { default as ViqReportBriefing } from '../../components/viq/ViqReportBriefing.vue'
export { default as ViqReportExecSummary } from '../../components/viq/ViqReportExecSummary.vue'
export { default as ViqReportOutlineEditor } from '../../components/viq/ViqReportOutlineEditor.vue'
export { default as ViqReportPanel } from '../../components/viq/ViqReportPanel.vue'
export { default as ViqReportSectionStream } from '../../components/viq/ViqReportSectionStream.vue'
export { default as ViqReportTypeSelector } from '../../components/viq/ViqReportTypeSelector.vue'
export { default as ViqShareDialog } from '../../components/viq/ViqShareDialog.vue'
export { default as ViqSidebar } from '../../components/viq/ViqSidebar.vue'
export { default as ViqSlideOut } from '../../components/viq/ViqSlideOut.vue'
export { default as ViqSourceCard } from '../../components/viq/ViqSourceCard.vue'
export { default as ViqSourceCards } from '../../components/viq/ViqSourceCards.vue'
export { default as ViqSubscriptionBar } from '../../components/viq/ViqSubscriptionBar.vue'
export { default as ViqTimeline } from '../../components/viq/ViqTimeline.vue'
export { default as ViqTimelineEvent } from '../../components/viq/ViqTimelineEvent.vue'
export { default as ViqUpsellJurisdictions } from '../../components/viq/ViqUpsellJurisdictions.vue'
export { default as ViqWelcome } from '../../components/viq/ViqWelcome.vue'

// nuxt/nuxt.js#8607
function wrapFunctional(options) {
  if (!options || !options.functional) {
    return options
  }

  const propKeys = Array.isArray(options.props) ? options.props : Object.keys(options.props || {})

  return {
    render(h) {
      const attrs = {}
      const props = {}

      for (const key in this.$attrs) {
        if (propKeys.includes(key)) {
          props[key] = this.$attrs[key]
        } else {
          attrs[key] = this.$attrs[key]
        }
      }

      return h(options, {
        on: this.$listeners,
        attrs,
        props,
        scopedSlots: this.$scopedSlots,
      }, this.$slots.default)
    }
  }
}
